import React, { Component,useState } from "react";
import ReactDOM from "react-dom";

import { API_URL } from "../../config";
import $, { data } from "jquery";
import Addsingle from "./orderaddnew";
import ViewOrderNew from "./vieworderNew";
import "./order.css";
import BlockUi from "react-block-ui";
import { SwalBlokUI } from "../../config";
import { SwalUnBlokUI } from "../../config";
import { ShowSwallError } from "../../config";
import { isEmpty } from "../../config";
import Swal from "sweetalert2";
import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import swalClass from "../OrderComponent/OrderSummaryTable.css"
import Dialog from "react-bootstrap-dialog";
//import ReactTooltip from 'react-tooltip';
import ReactTooltip from 'react-tooltip';


var totalItemValue;

let cust_status_flag = '';
let block_sale_flag = '';
let totalOrderValue=0;


class Order extends Component {


  


  constructor() {
    super();
    this.toggleBlocking = this.toggleBlocking.bind(this);
    this.CheckWHPPCFlag = this.CheckWHPPCFlag.bind(this);
    this.HandleOnchangeDist = this.HandleOnchangeDist.bind(this);
    this.Vieword = this.Vieword.bind(this);
    this.SubmitAfterConfirm = this.SubmitAfterConfirm.bind(this);
    this.AddToCart = this.AddToCart.bind(this);   
    var today = new Date(),
      date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();

    this.state = {
      blocking: false,
      currentDate: date,
      emailID: "",
      pwd: "",
      loginIP: "",
      loginBrowser: "",
      deviceType: "",
      userLocation: "",
      logIsp: "",
      ii: 0,
      show_search: 0,
      actions: [],
      pLogo: "",
      opcarr: [],
      count: 1,
      subject: [{ num: "", answer: "" }],
      sodet: [],
      distdet: [],
      productClass: [],
      productFamily: [],
      productfam: [],
      itemdet: [],
      idx: 0,
      fullItemList:[],
      itemList: [],
      proclass: "",
      distCode: localStorage.getItem("customerCode"),
      totalA: 0,
      cartDetails: [],
      cartItemsDetails: [],
      itemsToShow: [],
      filterDisable:[],
      qtyInputFlag:0
    };
  }
  

  CheckWHPPCFlag(distCode) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({
        dist_code: distCode,
      }),
    };

    

    SwalBlokUI("Please wait..");
    
    let logourl = API_URL + "/create_sales_order/CheckWHPPCFlag";
    
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        SwalUnBlokUI();
        if (json.hasOwnProperty("error")) {
          Swal.fire(
            "Error",
            json.status + "  " + json.error + "</br>" + json.message,
            "warning"
          );
        } else {
          let wh_flag = json.data.wh_flag;
          let ppc_flag = json.data.ppc_flag;
          cust_status_flag = json.data.cust_status;
          block_sale_flag = json.data.block_sale;

          let msg = "";
          let err = 0;
          if (wh_flag == "1") {
            err++;
            msg +=
              "</br><span style='color:red'>Location Not Found in Warehouse Master,please contact support.partner@weikfield.com with the error message.</span>";
          }
          if (ppc_flag == "1") {
            err++;
            msg +=
              "</br><span style='color:red'>Price Page code not updated in customer master,please contact support.partner@weikfield.com with the error message.</span>";
          }
          if (cust_status_flag == "1") {
            err++;
            msg +=
              "</br><span style='color:red'>Customer Status is INACTIVE,please contact support.partner@weikfield.com with the error message.</span>";
          }
          if (block_sale_flag == "1") {
            err++;
            msg +=
              "</br><span style='color:red'>Sale is BLOCKED for this Partner Code,please contact support.partner@weikfield.com with the error message.</span>";
          }

          if (err > 0) {
            Swal.fire({
              title: "OOPS!",
              html: msg,
              icon: "warning",
            });
          }

          if(block_sale_flag==="0"){

            console.log(localStorage.getItem("customerCode").length);
            console.log(this.state.distCode);
            localStorage.setItem("customerCode",this.state.distCode);

            if(this.state.distCode.length>1)
             
              this.itemdekhao(true, 1);
            
          }
        }
      })
      .catch((e) => {
        SwalUnBlokUI();
        Swal.fire({
          title: "OOPS!..",
          text: e,
          icon: "warning",
        });
        console.log(e);
      });
  }

  toggleBlocking() {
    this.setState({ blocking: !this.state.blocking });
  }
  
  componentDidMount() {
    //console.clear();
    
    this.getdist();
    this.productfam();
    let h =
      $(window).height() -
      $(".header-navbar").height() -
      $("#top_header").height() -
      $("#bottom_header").height() -
      180;

    $("#order_tbody").css("height", h + "px");

    this.CheckWHPPCFlag(localStorage.getItem("customerCode"));

    if(block_sale_flag==="0"){
      this.itemdekhao(true, 1)
    }
    
  }

  addSubject = (e) => {
    if (document.getElementsByName("batchsubjectadd").length > 5) {
      console.log("Overflow adding");
      Swal({
        title: "Error!",
        html: "You cannot add more than six details",
        icon: "warning",
        button: "OK",
      });
    } else {
      this.setState((prevState) => ({
        subject: [...prevState.subject, { num: "", answer: "" }],
      }));
    }
  };

  deleteSubject = (e) => {
    //  alert()
    console.log("Deleting option");
    const subjectnew = this.state.subject;
    subjectnew.splice(e, 1);
    this.setState({ subjectnew });
    // console.log("Deleting option")
    // const chapternew = this.state.chapter;
    // chapternew.splice(e, 1);
    // this.setState({ chapternew });
  };
  getemp() {
    // let pwd = document.getElementById("login-password").value
    // let email = document.getElementById("login-email").value

    // if (email == '' || pwd == '') {
    //     swal({
    //         title: "OOPS!",
    //         text: "Please enter your email and password!",
    //         icon: "warning",
    //     });

    //     return;
    // }
    //////////////////////////////
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    let logourl = API_URL + "/allSalesOrders";
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        $(".loading").addClass("d-none");

        this.setState({ sodet: json });
        console.clear();
      })
      .catch((e) => {
        $(".loading").addClass("d-none");


        console.log(e);
      });
    //////////////////////////////
  }

  checkQtyEntryFlag = (bp,data,parentcode) => {
    
    if(data > 0 ){
      
       if(bp==0){
        Swal.fire({
          title: "OOPS!",
          html: "Basic Price is missing, please contact Partner Portal Admin",
          icon: "error",
          button: "OK",
        });
        document.getElementById("qty_" + parentcode).value=0;
        this.state.qty=0;
        
        
       }else{
       this.state.qtyInputFlag=1;
       this.setState({filterDisable: true});
       }
     }

  }
 //Ennovation changes: Method added for handling click on Add to cart in order to retain previous selected items
  AddToCart()
  {
      const uniqueItems = new Set();
      const filteredItems = this.state.cartItemsDetails.reverse(i=>i);//.filter( (i) => i.qty > 0);
      const filteredUniqueItems = filteredItems.filter((obj) => {
        const alreadyPresent = uniqueItems.has(obj.itemcode);
        uniqueItems.add(obj.itemcode);
        return !alreadyPresent;
      });
      var updatedArray=this.state.itemsToShow;
      for(var i=0; i< updatedArray.length; i++)
      {
        for(var j=0; j<filteredUniqueItems.length; j++)
        {
          if(updatedArray[i].itemcode === filteredUniqueItems[j].itemcode)
          {
            //updatedArray.filter(i=>i.itemcode != filteredUniqueItems[j].itemcode);
            updatedArray[i].qty = filteredUniqueItems[j].qty;
            updatedArray[i].totalAmount = filteredUniqueItems[j].totalAmount;
           // this.setState({itemList:[...this.state.it]})            
          }
        }
      }
      
      var updatedFullArray=this.state.itemList;
      for(var i=0; i< updatedFullArray.length; i++)
      {
        for(var j=0; j<filteredUniqueItems.length; j++)
        {
          if(updatedFullArray[i].itemcode === filteredUniqueItems[j].itemcode)
          {
            //updatedArray.filter(i=>i.itemcode != filteredUniqueItems[j].itemcode);
            updatedFullArray[i].qty = filteredUniqueItems[j].qty;
            updatedFullArray[i].totalAmount = filteredUniqueItems[j].totalAmount;
           // this.setState({itemList:[...this.state.it]})            
          }
        }
      }
      this.setState({itemsToShow: updatedArray});
     // this.setState({cartDetails: updatedArray.filter(i=>i.item_qty>0)});
      this.setState({itemList: updatedFullArray});
     // console.log("updatedFullArray :",updatedFullArray);
     // console.log("updatedArray :",updatedArray);
      var updatedCartDetails=this.state.cartDetails;
    if(this.state.cartDetails.length<1)
    {
      this.setState({cartDetails:[...this.state.cartDetails.concat(filteredUniqueItems.filter(e=>e.qty>0))]});
      this.setState({totalA:(filteredUniqueItems.filter(e=>e.qty>0).reduce((a,v) =>  a =  a+v.qty*v.itemprice , 0 )).toFixed(2) });
     // console.log("filteredUniqueItems :",filteredUniqueItems);
    }
    else{
    for(var i=0; i<  filteredUniqueItems.length; i++)
    {
      for(var j=0; j<updatedCartDetails.length; j++)
      {
        if(filteredUniqueItems[i].itemcode === updatedCartDetails[j].itemcode)
        {
          //updatedArray.filter(i=>i.itemcode != filteredUniqueItems[j].itemcode);
          updatedCartDetails[j].qty = filteredUniqueItems[i].qty;
      
      
          updatedFullArray[j].totalAmount = filteredUniqueItems[i].totalAmount;
         // this.setState({itemList:[...this.state.it]})            
        }        
      }
      if(updatedCartDetails.length>0 && updatedCartDetails.filter(e=>e.itemcode==filteredUniqueItems[i].itemcode).length<1)
     {
        updatedCartDetails.push(filteredUniqueItems[i]);
      }
    }
    this.setState({cartDetails:updatedCartDetails.filter(e=>e.qty>0)});    
    this.setState({totalA:(updatedCartDetails.filter(e=>e.qty>0).reduce((a,v) =>  a = a + v.qty*v.itemprice , 0 )).toFixed(2) });
   // console.log("updated cart details are :",updatedCartDetails);
  }

    this.state.qtyInputFlag=0;
    this.setState({filterDisable: false});
   
      //this.setState({cartDetails:[...this.state.cartDetails.concat(filteredUniqueItems)]});
      this.setState({cartItemsDetails:[]}); 
      Swal.fire({
        html:'Items added/updated in cart successfully'
      })   ;


  }
// End
    
  

  SubmitAfterConfirm() {
    if(this.state.cartDetails.length==0){
      Swal.fire({
        title: "OOPS!",
        text: "Your Cart is empty, please click on the Add to Cart Button.",
        icon: "error",
      });
      return;
    }
    if (this.state.distCode == "") {
      Swal.fire({
        title: "OOPS!",
        text: "Please Select Distributor!",
        icon: "warning",
      });
      return;
    }
    if (this.state.totalA == 0) {
      Swal.fire({
        title: "OOPS!",
        text: "Please Select some item to save the order!",
        icon: "warning",
      });
      return;
    }

    const jsonSummaryTable = JSON.stringify(this.state.cartDetails);
    const jsonObj = JSON.parse(jsonSummaryTable);

    const cartSize = this.state.cartDetails.length;

    let summaryTable ="<p font-family: 'Georgia, serif;'><h1>O R D E R&nbsp;&nbsp;&nbsp;&nbsp;S U M M A R Y </h1></p>";
    let orderValue = 0;
    
    summaryTable +="<p><h5>Total Lines :"+cartSize+"</h5></p>";
    
    summaryTable +="<p text-align:'right'><h5>Total Order Value :&#x20B9;"+this.state.totalA+"</h5></p>";

    summaryTable +="<table class='table'><tr><th bgcolor='powderblue'>Line No</th><th bgcolor='powderblue'>Parent Code</th><th bgcolor='powderblue'>Item Name</th><th bgcolor='powderblue'>Order Qty</th><th bgcolor='powderblue'>Order Price</th><th bgcolor='powderblue'>Order Value</th>"
   
    for (let i = 0; i < cartSize; i++) {
     orderValue =orderValue+(jsonObj[i].qty*jsonObj[i].itemprice);
      
      summaryTable+="<tr><td>"+(i+1)+"</td><td>"+jsonObj[i].itemcode+"</td><td>"+jsonObj[i].itemname+"</td><td>"+jsonObj[i].qty+"</td><td>&#x20B9;"+jsonObj[i].itemprice+"</td><td>&#x20B9;"+(jsonObj[i].qty*jsonObj[i].itemprice).toFixed(2)+"</td></tr>";

    }
    
    summaryTable+="</table>";
 
    

      
    
Swal.fire({
  html : summaryTable,
  showDenyButton: true,
  showCancelButton: false,
  confirmButtonText: "Place Order",
  denyButtonText: "Add More Items",
  width: '90%',
  customClass: 'swal-height',
  allowOutsideClick: false,
  allowEscapeKey: false,
}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    this.submit();
  } else if (result.isDenied) {
    // Swal.fire('Changes are not saved', '', 'info')
  }
});



    // this.dialog.show({
    //     body: "You are going to save your order, are you sure or want to add few more item",

    //     actions: [
    //       Dialog.CancelAction(),
    //       Dialog.OKAction((dialog) => {

    //         this.submit();
    //       })
    //     ]
    //   });
  }

  submit() {
    SwalBlokUI("Please wait while your order is being placed");

    // let arr1 = [];
    // this.state.cartDetails.map(e=> {
      
    //     let data33 = {
    //       itemcode: e.itemcode,
    //       itemname:  e.itemname,
    //       parentcode:  e.parentcode,
    //       parentcodedescription:  e.parentcodedescription,
    //       productFamily:  e.productFamily,
    //       productClass:  e.productClass,
    //       uom:  e.uom,
    //       bo_qty:  e.bo_qty,
    //       moq:  e.moq ,
    //       itemprice:  e.itemprice,
    //       qty:  e.qty,
    //     };
    //     arr1.push(data33);      
    // });
    let distName = "";
    if (localStorage.getItem("userType").toLowerCase == "distributor") {
      distName = localStorage.getItem("userName");
    } else {
      distName = $("#dist option:selected").text();
    }
    let data1 = {
      distCode: this.state.distCode,
      itemList: this.state.cartDetails,
      distName: distName,
      LoogedInEmpCode: localStorage.empCode,
      LoogedInUserType: localStorage.getItem("userType"),
    };
    console.log(data1);
    
    // let arr = JSON.parse(localStorage.getItem("doc"))
    // arr.push(data)

    // localStorage.setItem("doc", JSON.stringify(arr))
    //////
    let logourl = API_URL + "/create_sales_order/PlaceOrderNew";
    let msg = "Added Sucessfully";

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify(data1),
    };
    // console.log("requestOptions is:",requestOptions)
    // alert("order request :"+JSON.stringify(requestOptions))
    function handleErrors(response) {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      Swal({
        title: "Error!",
        text: response.statusText,
        icon: "warning",
      });
      return response;
    }
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        SwalUnBlokUI();
        if (json.hasOwnProperty("error")) {
          let trace = "";
          if (json.hasOwnProperty("trace"))
            trace = "<span style='color:red;'>" + json.trace + "</span><br>";
          Swal.fire(
            "Error",
            trace + json.status + "  " + json.error + "</br>" + json.message,
            "warning"
          );
        } else {
          //this.setState({ totalA: 0 });
          let err_cnt = json.data.err_cnt;
          let msg = json.data.msg;
          if (err_cnt == 0) {
            Swal.fire({
              title: "Done!",
              html: msg,
              icon: "success",
            });
            this.reset();
            this.componentDidMount();
            this.Vieword();
          } else {
            Swal.fire({
              title: "Error!",
              html: msg,
              icon: "warning",
            });
          }
          //this.postorder(json.customerRefNo)
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "OOPS!..",
          text: err,
          icon: "warning",
        });
      });
    //////
  }


  postorder(val) {
    let data1 = {
      order_number: val,
    };
    let logourl =
      API_URL + "/sap_sales_order/PushSalesOrderToSap?order_number=" + val;
    //  alert()
    let msg = "Your order number is " + val;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({
        order_number: val,
      }),
    };

    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        console.log(json);

        if (1 == 1) {
          Swal({
            title: "Done!",
            text: msg + "....." + json.data.msg,
            icon: "success",
          });

          this.reset();
          this.setState({ totalA: 0 });
          this.componentDidMount();
        }
      })
      .catch((e) => {
        ShowSwallError(e);
      });
    //////s
  }
  reset() {
    document.getElementById("pordfam").value = " ";
    document.getElementById("pordcls").value = " ";
    this.setState({ itemList: [] });
    this.setState({ show_search: 0 });
  }
  getdist() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };


    

    let logourl = API_URL + "/allCustomers";
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        $(".loading").addClass("d-none");

        this.setState({ distdet: json });
      })
      .catch((e) => {
        ShowSwallError(e);
        console.log(e);
      });

    // }
  }

  productfam() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    let data1 = {};
    let logourl = API_URL + "/getDistinctProductFamily";
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        $(".loading").addClass("d-none");

        this.setState({ productfam: json });
      })
      .catch((e) => {
        $(".loading").addClass("d-none");

        console.log(e);
      });

    // }
  }

  productClass(val) {
    this.setState({ proclass: val });
    let data1 = {
      productFamily: val,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify(data1),
    };

    let logourl = API_URL + "/getDistinctProductClass";
    fetch(logourl, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        $(".loading").addClass("d-none");

        this.setState({ productClass: json });
      })
      .catch((e) => {
        $(".loading").addClass("d-none");

        console.log(e);
      });

    // }
  }
  
  itemdekhao(val, i) {

    this.setState({ totalA: 0 });

    this.setState({ itemList: [] });
    

    let url = API_URL + "/create_sales_order/GetDisplayListItems";
      $("#pordfam").val(" ");
      $("#pordcls").val(" ");
    this.setState({filterDisable: false});

    this.toggleBlocking();
    let data1 = {

      distCode: this.state.distCode,
      productClass: $("#pordcls").val(),
      productFamily: $("#pordfam").val(),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify(data1),
    };

    fetch(url, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        $(".loading").addClass("d-none");

        this.toggleBlocking();
        if (json.data.length > 0) this.setState({ show_search: 1 });
        else this.setState({ show_search: 0 });
        this.setState({ itemList: json.data });
        this.setState({fullItemList :json.data});
        this.setState({ itemsToShow: json.data });
        
      })
      .catch((e) => {
        $(".loading").addClass("d-none");

        console.log(e);
      });
    //     let arr=[]
    // for(let i=0;i<this.state.itemList.length;i++){
    // if(val==this.state.itemList[i].productClass){
    //     arr.push(this.state.itemList[i])
    //     this.setState({itemdet:arr})
    // }
    // }
  }
  popitemdet(val, idx) {
    // debugger
    let arr = [];
    for (let i = 0; i < this.state.itemdet.length; i++) {
      if (val == this.state.itemdet[i].itemcode) {
        //  alert(this.state.itemdet[i].itemname)
        document.getElementById(idx + "itname").value =
          this.state.itemdet[i].itemname;
        document.getElementById(idx + "itstock").value =
          this.state.itemdet[i].qty;

        document.getElementById(idx + "ituom").value =
          this.state.itemdet[i].uom;
        document.getElementById(idx + "itprice").value =
          this.state.itemdet[i].itemprice;
        // this.addSubject()
        // arr.push(this.state.itemList[i])
        // this.setState({itemdet:arr})
        return;
      } else {
        document.getElementById(idx + "itname").value = "";
        document.getElementById(idx + "itstock").value = "";

        document.getElementById(idx + "ituom").value = "";
        document.getElementById(idx + "itprice").value = "";
      }
    }
  }
  Vieword() {
    console.log("hi");

    ReactDOM.render(<ViewOrderNew />, document.getElementById("c11"));
  }

  moqverify(ele, moq, total, oq, code, session,bp) {
      var cartItem;
    /*
       if(oq<moq && oq!=0){
        swal({
            title: "Error!",
            text: "Order quantity should be greater than or equal to MOQ",
            icon: "warning",
        });
    }
       else  */
    if (1) {
      //validation
      const re = /^[0-9\b]+$/;
      if (oq === "" || re.test(oq)) {
        console.log("is a number"+oq);
        
      } else {
        console.log("not a number");
        $("#qty_" + code).val(0);
        ele.innerHTML = 0;
        return false;
      }
      ele.innerHTML = total.toFixed(2);
      const totVal=this.calculateTotalVal();
      //Ennovation changes:updating state with selected item
      if(bp==0){
        oq=0;
      }
      
         cartItem = {
          itemcode: session.itemcode,
          itemname: session.itemname,
          parentcode: session.parentcode,
          parentcodedescription: session.parentcodedescription,
          productFamily: document.getElementById("pordfam").value,
          productClass:  document.getElementById("pordcls").value,
          uom: session.uom,
          bo_qty: session.bo_qty,
          git:session.git,
          moq: session.minorderqty,
          itemprice: session.basicprice,
          qty: oq
          //totalAmount: totalItemValue
        };
        this.setState({
            cartItemsDetails: [...this.state.cartItemsDetails,cartItem]});
        // console.log("cartitem details are :",cartItem)
       //End
      
    }
  }
  calculateTotalVal() {
    let tot = 0;
    $.each($('td[name="pc"]'), function (k, v) {
      var new_tot = $("#" + $(this).attr("parent_fg_code")).html();
     // console.log("num details :", $("#" + $(this).attr("parent_fg_code")));
     // console.log("qty details :", $("#qty_" + $(this).attr("parent_fg_code")));
      //console.log("total :" + new_tot);
      // {

      // }
      if (new_tot == "" || new_tot == "undefined") new_tot = 0;
      new_tot = parseFloat(new_tot);
      tot += new_tot;
     
    });
    
    tot = tot.toFixed(2);
    this.setState({ totalA: tot });
  }

  HandleOnchangeDist(data) {
    this.setState({ distCode: data.target.value });
    this.CheckWHPPCFlag(data.target.value);
    this.reset();
    
  }

  handleTabelSearch = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ");
      var search = $("#table_search").val();

      if (search == "") {
        $("#order_table tr").removeClass("order_active");
        return;
      }

      var tr_id = $("#order_table td:contains(" + search + ")")
        .parent()
        .attr("id");
      console.log("tr_id : " + tr_id);

      if (tr_id == undefined) {
        $("#order_table tr").removeClass("order_active");
        return;
      }

      $("#order_table tr").removeClass("order_active");
      $("#" + tr_id).addClass("order_active");

      $("#order_table tbody").scrollTop(
        $("#order_table tbody tr.order_active").offset().top +
          $("#order_table tbody").scrollTop() -
          $("#order_table tbody").offset().top
      );
    }
  };
  render() {
    let { subject, idx } = this.state;

    return (
      <>
        <ReactTooltip />
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
          <div class="content-header row"></div>

          <Dialog
            ref={(component) => {
              this.dialog = component;
            }}
          />
          <div class="content-body">
            <section class="invoice-add-wrapper">
              <div class="row invoice-add">
                <div class="col-xl-12  col-12">
                  <div class="card invoice-preview-card">
                    <div
                      class="card-body invoice-padding pt-0"
                      id="top_header"
                      style={{ paddingBottom: "1px", marginBottom: "1px" }}
                    >
                      <div
                        class="row row-bill-to invoice-spacing"
                        style={{ paddingBottom: "1px", marginBottom: "1px" }}
                      >
                        <div class="col-xl-4 mb-lg-1 col-bill-to pl-0">
                          <h6 class="invoice-to-title mb-1">Order Date:</h6>
                          <div class="invoice-customer">
                            <input
                              type="text"
                              readOnly
                              id="DOB"
                              defaultValue={this.state.currentDate}
                              class="form-control flatpickr-basic"
                              placeholder=""
                            />
                          </div>
                        </div>
                        {localStorage.getItem("userType") !== "distributor" ? (
                          <div class="col-xl-4 mb-lg-1 col-bill-to pl-0">
                            <h6 class="invoice-to-title mb-1">Distributor:</h6>
                            <div class="invoice-customer">
                              <select
                                id="dist"
                                onChange={this.HandleOnchangeDist}
                                name="distcode"
                                class="invoiceto form-control"
                              >
                                <option value=" ">Select</option>
                                {this.state.distdet.map((session) => (
                                  <option value={session.customerCode}>
                                    {session.customerName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        ) : null}
                        {localStorage.getItem("userType") !== "distributor" ? (
                          <div class="col-xl-4 mb-lg-1 col-bill-to pl-0">
                            <h6 class="invoice-to-title mb-1">Sale Person:</h6>
                            <div class="invoice-customer">
                              <input
                                type="text"
                                id="DOB"
                                defaultValue={localStorage.getItem("userName")}
                                readOnly
                                class="form-control "
                                placeholder=""
                              />
                            </div>
                          </div>
                        ) : null}
                        <div class="col-xl-4 mb-lg-1 col-bill-to pl-0">
                          <h6 class="invoice-to-title mb-1">Product Line:</h6>
                          <div class="invoice-customer">
                            <select
                              id="pordfam"
                              onChange={(data) =>
                               { //const itemsToShow = this.state.itemList.filter((i)=>i.pdt_family == data.target.value)
                               // this.setState({itemShowList:itemsToShow});
                               // alert(JSON.stringify(itemsToShow));
                               var itemFamilyShowList=this.state.itemsToShow;
                              
                              //alert(data.target.value)
                              //  if(data.target.value == " ")
                              //   {
                              //       itemFamilyShowList = this.state.itemList;
                              //    }

                                 if(data.target.value == " ")
                                 {
                                  itemFamilyShowList = this.state.itemList;
                                 }
                                 else
                                 {
                                  itemFamilyShowList= this.state.itemList.filter((i)=>i.pdt_family == data.target.value)
                                 }
                                 this.setState({itemsToShow : []});
                               // this.setState({itemsToShow : itemFamilyShowList});
                                this.productClass(data.target.value)
                               }
                                // this.productClass(data.target.value)
                              }
                              class="invoiceto form-control"  
                              disabled={this.state.filterDisable}                           
                            >
                              <option value=" ">Select</option>
                              {this.state.productfam.map((session) => (
                                <option value={session.productFamily}>
                                  {session.productFamily}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div class="col-xl-4 mb-lg-1 col-bill-to pl-0">
                          <h6 class="invoice-to-title mb-1">Flavour:</h6>
                          <div class="invoice-customer">
                            <select
                              id="pordcls"
                              onChange={(data) =>{
                                setTimeout(()=>{ //Start the timer
                                  this.setState({itemsToShow : []});
                              }, 100)
                                
                                var itemShowList;
                               // console.log("updated state is :"+JSON.stringify(this.state.itemsToShow))
                               if(this.state.qtyInputFlag===1){
                                this.setState({filterDisable: true});
                               }
                                if(data.target.value == " ")
                                {
                                  this.setState({itemsToShow : []});
                                    itemShowList = $("#pordfam").val() != " "?this.state.itemList.filter((i)=>i.pdt_family == $("#pordfam").val()):this.state.itemList;

                                }
                                else
                                {
                                  this.setState({itemsToShow : []});
                                    //itemShowList= this.state.itemList.filter((i)=>i.pdt_class == data.target.value)
                                    itemShowList= this.state.itemList.filter((i)=>i.pdt_family == $("#pordfam").val() && i.pdt_class == data.target.value);
                                }
                                setTimeout(()=>{ //Start the timer
                                  this.setState({itemsToShow : itemShowList});
                              }, 100)
                                }
                              }
                              name="prodclass"
                              class="invoiceto form-control"
                              disabled={this.state.filterDisable}    
                            >
                              <option value=" ">Select</option>
                              {this.state.productClass.map((session) => (
                                <option value={session.productClass}>
                                  {session.productClass}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div class="col-xl-2 mb-lg-1 col-bill-to pl-0">
                        <h6 class="invoice-to-title mb-1">
                             Total Lines
                            </h6>
                          <div class="invoice-customer">
                                {this.state.fullItemList.length}
                          </div>
                        </div>

                        {this.state.show_search === 1 && (
                          <div class="col-xl-2 mb-lg-1 col-bill-to pl-0">
                            <h6 class="invoice-to-title mb-1">
                              Enter to search
                            </h6>
                            <div class="invoice-customer">
                              <input
                                type="text"
                                id="table_search"
                                class="form-control "
                                onKeyPress={this.handleTabelSearch}
                              />
                            </div>
                          </div>
                        )}

                        
                      <div>
                      </div>
                      </div>


                    </div>
                        

                    <hr class="invoice-spacing mt-0" />
                    <BlockUi
                      tag="div"
                      blocking={this.state.blocking}
                      message="Loading, please wait"
                      color="red"
                    >
                        <div class="card-body " style={{ paddingTop: "1px" }}>
                        <table
                          id="order_table"
                          class="table-responsive datatables-basic table p-0 m-0 shadow table-hover table-sm"
                        >
                          <thead class="table-header">
                            <tr key={-1}>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                }}
                              >
                                {" "}
                                Parent Code{" "}
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  width: "35%",
                                }}
                              >
                                Parent Code Desc
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center",
                                }}
                                data-html={true}
                                data-background-color="#33A5FF "
                                data-tip="<p>Physical Inventory lying at depot</p>"
                              >
                              W/h Stock  
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center"
                                }}
                                data-html={true}
                                data-background-color="#33A5FF "
                                data-tip="<p>Allocated qty not shipped yet. <br> This qty gets reduced from Physical Inventory after despatch.</p>"
                              >
                              Alloc. Qty
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center"
                                }}
                              >
                                Price
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center"
                                }}
                              >
                                UOM
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center",
                                }}
                              >
                                Qty
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#64a179",
                                  color: "#FFF",
                                  fontSize: "0.9em",
                                  textAlign: "center",
                                }}
                              >
                                Total Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            table-hover-animation
                            class="table-wrapper-scroll-y my-custom-scrollbar"
                            id="order_tbody"
                          >
                              {/* {alert(JSON.stringify(this.state.itemList))} */}
                            {/* {this.state.itemList.map((session, index) => ( */}
                            {this.state.itemsToShow.map((session, index) => (
                              <tr
                                style={{
                                  backgroundColor:
                                    index % 2 === 1 ? "#e8f5e2" : "#ffffff",
                                }}
                                id={index + 1}
                                name={index + 1}
                                key={index}
                              > 
                                <td
                                  name="pc"
                                  parent_fg_code={session.parentcode}
                                >
                                  {session.parentcode} &nbsp;
                                  <i
                                    class={
                                      session.bucketcode == "1"
                                        ? "fas fa-flag  mr-50 font-green"
                                        : session.bucketcode == "2"
                                        ? "fas fa-flag  mr-50 font-blue"
                                        : "fas fa-flag  mr-50 "
                                    }
                                  ></i>{" "}
                                </td>
                                <td class="d-none" name="ic">
                                  {session.itemcode}
                                </td>
                                <td class="d-none" name="in">
                                  {session.itemname}
                                </td>
                                <td class="d-none" name="bo_moq">
                                  {session.minorderqty}
                                </td>
                                <td name="pcd" style={{ width: "35%" }}>
                                  {session.parentcodedescription}
                                </td>
                                <td name="git" style={{ textAlign : "center" }}>
                                  {session.git}
                                </td>
                                <td name="bo_qty" style={{ textAlign : "center" }}>
                                {session.bo_qty}
                                </td>

                                <td name="bp" style={{ textAlign : "center" }}>{session.basicprice.toFixed(2)}</td>
                                <td name="uom" style={{ textAlign : "center" }}>{session.uom}</td>

                                <td style={{ textAlign: "right" }} class="p-1">
                                  <input
                                  Value="0"
                                    //placeholder={session.item_qty}
                                   // value={session.qty !=0?session.qty:this.sta964te.qtyInput}//"0"
                                    id={"qty_" + session.parentcode}
                                    type="text"
                                    maxLength="3"
                                    onBlur = {(data) => this.checkQtyEntryFlag(session.basicprice,data.target.value,session.parentcode)}
                                    onChange={(data) =>
                                     {
                                      this.moqverify(
                                        document.getElementById(
                                          session.parentcode
                                        ),
                                        session.minorderqty,
                                        session.basicprice * data.target.value,
                                        data.target.value,
                                        session.parentcode,
                                        session,
                                        session.basicprice
                                      )
                                        } 
                                    }
                                    name="qty"
                                    class="form-control form-control-sm p-1 number"
                                    defaultValue={session.qty}
                                  />
                                </td>
                                <td
                                  class="number"
                                  style={{ color: "red", textAlign: "right" }}
                                  id={session.parentcode}
                                >
                                 {(session.qty * session.basicprice).toFixed(2)
                                 }
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </BlockUi>
                    <div class=" invoice-padding">
                      <div class="row invoice-sales-total-wrapper">
                        <div class="col-md-6 d-flex justify-content-end order-md-2 order-1"></div>
                      </div>
                    </div>

                    <hr class="invoice-spacing mt-0" />

                    <div
                      id="bottom_header"
                      class="card-body invoice-padding py-0"
                    >
                      <div class="row">
                        <div class="col-2">
                          <div class="form-group mb-2">
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-block btn-primary"
                              onClick={() => this.SubmitAfterConfirm()}
                            >
                              <i class="fas fa-save mr-50"></i>Create Order
                            </button>
                          </div>
                        </div>

                        <div class="col-2">
                          <div class="form-group mb-2">
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-block btn-primary"
                              onClick={() => this.AddToCart()}
                            >
                              <i class="fas fa-cart-plus mr-50"></i>Add to cart({this.state.cartDetails.length})
                            </button>
                          </div>
                        </div>



                        <div class="col-3" style={{ paddingTop: "7px" }}>
                          <div class="form-group mb-2">
                            <i class="fas fa-flag  mr-50 font-green">
                              &nbsp;New Launch&nbsp;
                            </i>
                            <i class="fas fa-flag  mr-50 font-blue">
                              &nbsp; Promo&nbsp;
                            </i>
                            <i class="fas fa-flag  mr-50  ">
                              {" "}
                              &nbsp;Balance SKU's&nbsp;
                            </i>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group mb-2"></div>
                        </div>
                        <div class="col-3">
                          <div class="form-group mb-2">
                              {/* Ennovation changes: Label for total items in cart */}
                          <h4
                              style={{
                                fontWeight: "bold",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                            {/* Items In Cart:&nbsp;{this.state.cartDetails.length} */}
                            </h4>
                             {/* End */}
                            <h4
                              style={{
                                fontWeight: "bold",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                              Total Amount:&nbsp;{this.state.totalA}
                            </h4>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}
export default Order;
